import { render, staticRenderFns } from "./AttendanceFileUploader.vue?vue&type=template&id=35372186&scoped=true&"
import script from "./AttendanceFileUploader.vue?vue&type=script&lang=js&"
export * from "./AttendanceFileUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35372186",
  null
  
)

export default component.exports